var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 13,
    viewBox: "0 0 21 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.04395 1H17.0439C18.1485 1 19.0439 1.89543 19.0439 3V3.24451H1.04395V3C1.04395 1.89543 1.93938 1 3.04395 1ZM1.04395 5.59555V10C1.04395 11.1046 1.93938 12 3.04394 12H17.0439C18.1485 12 19.0439 11.1046 19.0439 10V5.59555H1.04395ZM0.0439453 3C0.0439453 1.34315 1.38709 0 3.04395 0H17.0439C18.7008 0 20.0439 1.34315 20.0439 3V10C20.0439 11.6569 18.7008 13 17.0439 13H3.04394C1.38709 13 0.0439453 11.6569 0.0439453 10V3ZM2.17841 7.61218C2.17841 7.19797 2.51419 6.86218 2.92841 6.86218H11.6366C12.0508 6.86218 12.3866 7.19797 12.3866 7.61218C12.3866 8.0264 12.0508 8.36218 11.6366 8.36218H2.92841C2.51419 8.36218 2.17841 8.0264 2.17841 7.61218Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCard);
export default __webpack_public_path__ + "static/media/IconCard.507ea034.svg";
export { ForwardRef as ReactComponent };